import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FormataValorPositivo {

    constructor() { }

    formatarSaldoPositivo(saldo: number | string): number {
        if (typeof saldo === 'string') {
            saldo = parseFloat(saldo);
        }

        return Math.abs(saldo);
    }
}